import React from 'react';
import ButtonBlock from './ButtonBlock';

import { Typography } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    block: {
        "& .MuiButton-endIcon": {
            transitionDuration: theme.transitions.duration.standard,
            transitionTimingFunction: theme.transitions.easing.easeInOut,
            transitionProperty: "color",
            color: theme.palette.secondary.muted,
        },
        "&:hover": {
            textDecoration: "none",
        },
        "&:hover .MuiButton-endIcon": {
            color: theme.palette.primary.main,
        },
        borderRadius: 0,
    },
    heading: {
        //color: theme.palette.primary.main,
        margin: 0,
        //marginBottom: ".25rem",
    },
    text: {
        color: theme.palette.secondary.muted2,
        margin: 0, 
        marginTop: ".75rem",
    },
}));

export default function IconButtonBlock({ icon: Icon, text = '', heading, minHeight = "5.5em", ...props }) {

    const classes = useStyles();

    const largeIcon = () => <Icon style={{ fontSize: "1.5em" }} />;

    return (
        <ButtonBlock className={classes.block} style={{minHeight}} endIcon={largeIcon} padding="1rem 1rem" {...props}>
            <Typography variant="h6" className={classes.heading + " upper"}>{heading}</Typography>
            {text ?
                <Typography variant="body1" className={classes.text}>{text}</Typography>
                : ''
            }
        </ButtonBlock>
    );
}